import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">平台特色</h2>
          <p className="mt-2 text-sm text-foreground-600">黑料官网的核心优势与服务承诺</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featureItems.map((feature) => (
            <div
              key={feature.id}
              className="flex flex-col items-center text-center p-5 bg-background-50 rounded-lg border border-background-200 hover:border-primary-200 transition-all cursor-pointer"
            >
              <span className="w-11 h-11 flex items-center justify-center text-xl text-primary-500 bg-primary-100 rounded-full mb-4">
                <i className={feature.icon}></i>
              </span>
              <h3 className="text-sm font-semibold text-foreground-900 mb-2">{feature.title}</h3>
              <p className="text-xs text-foreground-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}